import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { SupplyItemDocument, supplyItemPullQueryBuilder } from './queryBuilder';

export function supplyItemsFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<SupplyItemDocument> {
  const syncConfig = configBuilder<SupplyItemDocument>(RxdbCollectionNameV2.SUPPLY_ITEMS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, supplyItemPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.SUPPLY_ITEMS, replicationState, [sites]);
}
